import "./TechnicalDivision.module.css";
import Header from "@/reusable_sections/Header";
import Identity from "./sections/Identity";
import Footer from "@/reusable_sections/Footer";
export default function TechnicalDivisionPage() {
  return <div>
      <Header />
      <Identity />
      <Footer />
    </div>;
}